import { Box, SxProps } from '@mui/material'
import { useTranslationsContext } from '@omnea-app/fe-i18n/TranslationsContext'
import { CountryCode } from '@omnea-app/legacy/utils/countries/countryCodes'
import { getCountryDisplayName } from '@omnea-app/legacy/utils/countries/getCountryDisplayName'
import { MuiTelInputCountry } from './PhoneNumberHelpers'

export type FlagProps = {
  isoCode: MuiTelInputCountry | CountryCode
  sx?: SxProps
  size?: number
}

export const Flag: React.FC<FlagProps> = ({ isoCode, sx, size = 26 }) => {
  const { locale } = useTranslationsContext()
  const countryName = getCountryDisplayName(locale, isoCode)

  return (
    <Box
      data-testid={isoCode}
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      {/* We're using a CDN to serve the flags, it's actually worse to use Next.js Image */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        srcSet={`https://flagcdn.com/w40/${isoCode.toLowerCase()}.webp`}
        src={`https://flagcdn.com/w40/${isoCode.toLowerCase()}.png`}
        loading="lazy"
        width={size}
        style={{ display: 'block' }}
        alt={countryName}
      />
    </Box>
  )
}
